var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanicalExtractFan01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,12.5c-2.5,0-4.4-2-4.4-4.4H8V12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.5,8c0-2.5,1.9-4.5,4.4-4.5c0,0,0.1,0,0.1,0V8H3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.5,8c0,2.5-2,4.4-4.4,4.4c0,0,0,0-0.1,0V8H12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,3.5c2.5,0,4.5,1.9,4.5,4.4c0,0,0,0.1,0,0.1H8V3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicalExtractFan01);
export default __webpack_public_path__ + "static/media/MechanicalExtractFan-01.4b0dd3fb4a7a7670236bc5a8d5ccac9a.svg";
export { ForwardRef as ReactComponent };